module.exports = __webpack_public_path__ + "static/media/samopoznanie.35e04395.jpg";